import styles from './Spinner.module.css';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize;
  /** Center in a full-width/height container */
  fullPage?: boolean;
  className?: string;
}

export function Spinner({ size = 'md', fullPage = false, className }: SpinnerProps) {
  const wrapperClass = [
    styles.wrapper,
    fullPage && styles.fullPage,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const svgClass = [styles.spinner, styles[size]].join(' ');

  return (
    <div className={wrapperClass} role="status" aria-label="Carregando">
      <svg
        className={svgClass}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      >
        <circle cx="12" cy="12" r="10" opacity="0.2" />
        <path d="M12 2a10 10 0 0 1 10 10" />
      </svg>
    </div>
  );
}
